import React, { useState, useRef } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import {
  fabricantes,
  unidadmedidas,
  marcas,
  modelos,
  tipoproducto,
  round,
} from "../../util/varios";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import * as XLSX from "xlsx";
import useTableScroll from "../useTableScroll";

const FileExcelClientes = () => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  const accbtnactxlsx = JSON.parse(sessionStorage.getItem("accbtnactxlsxc"));
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));

  const txtFile = useRef();
  const [insertProduct, setInsertProduct] = useState([]);
  const [updateProduct, setUpdateProduct] = useState([]);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [headCells, setHeadCells] = useState([]);
  const { TblContainer, TblHead } = useTableScroll(headCells);

  const procesarRegistro = (operacion, body) => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/agente/actualizarxlsx/${operacion}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setInsertProduct([]);
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: `${response.data.contar} registro creado correctamente`,
              icono: "exito",
            });
          } else if (operacion === 2) {
            setUpdateProduct([]);
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: `${response.data.contar} registro modificado correctamente`,
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: `${response.data.contar} registro eliminado correctamente`,
              icono: "exito",
            });
          }

          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRegistros = (productFile) => {
    let campos = "codigo";
    let nomtab = "producto";
    let orden = "idproducto";
    const datos = [];

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            for (let index = 0; index < response.data.length; index++) {
              datos.push(response.data[index].codigo);
            }
            procesarPrecioProd(datos, productFile);
          } else {
            setInsertProduct(productFile);
            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const updateProcess = () => {
    if (accbtnactxlsx && accbtnactxlsx.toString().substring(1, 2) === "1") {
      let productos = [];
      for (let i = 0; i < updateProduct.length; i++) {
        if (parseInt(updateProduct[i][3]) > 1) {
          productos.push({
            idfabricante: fabricantes[updateProduct[i][0]],
            codigo: updateProduct[i][1],
            nombre: updateProduct[i][2],
            nombrecorto: updateProduct[i][2],
            ivacompra: updateProduct[i][5],
            ivaventa: updateProduct[i][5],
            exento: parseFloat(updateProduct[i][5]) > 0.0 ? false : true,
            valorfactor:
              parseInt(updateProduct[i][3]) > 1 ? updateProduct[i][3] : 0.0,
            tipofactor: parseInt(updateProduct[i][3]) > 1 ? 1 : 0,
            idunidadmedida: unidadmedidas[updateProduct[i][11]],
            idunidadalterna: unidadmedidas["UNIDAD"],
            idunidadcompra: unidadmedidas[updateProduct[i][11]],
            idunidadventa: unidadmedidas[updateProduct[i][11]],
            marca: marcas[updateProduct[i][12]],
            idtipoproducto: tipoproducto[updateProduct[i][13]],
            modelo: modelos[updateProduct[i][14]],
            stockminimo: 1.0,
            metodocosto: "COSTO PROMEDIO",
            tipoprecio: "PRECIO POR DEFECTO",
            almacen: true,
            servicio: false,
            idmoneda: "4",
            costoproveedor: updateProduct[i][4],
            costocalculado: updateProduct[i][4],
            ultimocosto: updateProduct[i][4],
            costopromedio: updateProduct[i][4],
            utipreciomaxi: round(updateProduct[i][8]),
            utiprecioofe: round(updateProduct[i][8]),
            utipreciomayor: round(updateProduct[i][8]),
            utipreciomini: round(updateProduct[i][8]),
            costoproveedoralter: round(
              updateProduct[i][4] / updateProduct[i][3]
            ),
            costocalculadoalter: round(
              updateProduct[i][4] / updateProduct[i][3]
            ),
            ultimocostoalter: round(updateProduct[i][4] / updateProduct[i][3]),
            costopromedioalter: round(
              updateProduct[i][4] / updateProduct[i][3]
            ),
            utipreciomaxialter: round(updateProduct[i][8]),
            utiprecioofealter: round(updateProduct[i][8]),
            utipreciomayoralter: round(updateProduct[i][8]),
            utipreciominialter: round(updateProduct[i][8]),
          });
        } else {
          productos.push({
            idfabricante: fabricantes[updateProduct[i][0]],
            codigo: updateProduct[i][1],
            nombre: updateProduct[i][2],
            nombrecorto: updateProduct[i][2],
            ivacompra: updateProduct[i][5],
            ivaventa: updateProduct[i][5],
            exento: parseFloat(updateProduct[i][5]) > 0.0 ? false : true,
            valorfactor: 0.0,
            tipofactor: 0,
            idunidadmedida: unidadmedidas[updateProduct[i][11]],
            idunidadcompra: unidadmedidas[updateProduct[i][11]],
            idunidadventa: unidadmedidas[updateProduct[i][11]],
            marca: marcas[updateProduct[i][12]],
            idtipoproducto: tipoproducto[updateProduct[i][13]],
            modelo: modelos[updateProduct[i][14]],
            stockminimo: 1.0,
            metodocosto: "COSTO PROMEDIO",
            tipoprecio: "PRECIO POR DEFECTO",
            almacen: true,
            servicio: false,
            idmoneda: "4",
            costoproveedor: updateProduct[i][4],
            costocalculado: updateProduct[i][4],
            ultimocosto: updateProduct[i][4],
            costopromedio: updateProduct[i][4],
            utipreciomaxi: round(updateProduct[i][8]),
            utiprecioofe: round(updateProduct[i][8]),
            utipreciomayor: round(updateProduct[i][8]),
            utipreciomini: round(updateProduct[i][8]),
          });
        }
      }
      procesarRegistro(2, { productos: JSON.stringify(productos) });
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  const insertProcess = () => {
    if (accbtnactxlsx && accbtnactxlsx.toString().substring(1, 2) === "1") {
      let cliente = [];
      let datoPer = [];

      for (let i = 0; i < insertProduct.length; i++) {
        cliente.push({
          idagente: "0",
          nombre: insertProduct[i][1],
          direccion: insertProduct[i][2],
          tipoper: "1",
          rif: insertProduct[i][0],
          reprelegal: insertProduct[i][10] + insertProduct[i][3],
          telefono: insertProduct[i][5],
          celular: insertProduct[i][6],
          email: insertProduct[i][0] + insertProduct[i][4],
          cliente: true,
          statuscliente: "51",
          fechainscripcioncliente: fechasistema,
          estado: "22",
          municipio: "22370",
          ciudad: "2214",
          islr: "",
          grupcli: "",
          agenteretencion: false,
        });

        /*         datoPer.push({
          apellidos: insertProduct[i][6],
          cedula: insertProduct[i][3],
          correoe: insertProduct[i][4],
          direccion: insertProduct[i][2],
          fnacimiento: "1990-01-01",
          nacionalidad: insertProduct[i][9],
          nombres: insertProduct[i][6],
          sexo: insertProduct[i][10],
          tlf1: insertProduct[i][5],
          tlf2: insertProduct[i][5],
        }); */
      }

      let body = {
        operacionper: 0,
        agente: cliente,
        repre: [],
        client: [],
      };

      procesarRegistro(1, body);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  const handleInputChange = (e) => {
    if (accbtnactxlsx && accbtnactxlsx.toString().substring(0, 1) === "1") {
      if (e.target.name === "file" && e.target.files.length > 0) {
        setActivate(true);
        setHeadCells([]);
        setInsertProduct([]);
        setUpdateProduct([]);
        let hojas = [];
        let reader = new FileReader();
        reader.readAsArrayBuffer(e.target.files[0]);
        reader.onload = (e) => {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, { type: "array" });

          workbook.SheetNames.forEach(function (SheetName) {
            var objData = XLSX.utils.sheet_to_row_object_array(
              workbook.Sheets[SheetName]
            );
            hojas.push({
              data: objData,
              SheetName,
            });
          });

          let titulos = [];
          let produc = [];
          let titulo_sigue = false;
          let produc_sigue = false;
          let rueda = Object.keys(hojas[0].data[0]);
          try {
            for (let i = 0; i < rueda.length; i++) {
              titulos.push({
                label: rueda[i].toUpperCase(),
                textAlign: "center",
              });
            }
            titulo_sigue = true;
          } catch (error) {
            setMensaje({
              mostrar: true,
              titulo: "Error",
              texto: "el archivo xlsx esta mal formado",
              icono: "error",
            });
            setActivate(false);
          }

          try {
            for (let l = 0; l < hojas[0].data.length; l++) {
              let obj = {};
              let array = Object.values(hojas[0].data[l]);
              for (let k = 0; k < array.length; k++) {
                obj[k] = array[k];
              }
              produc.push(obj);
            }
            produc_sigue = true;
            setActivate(false);
          } catch (error) {
            setMensaje({
              mostrar: true,
              titulo: "Error",
              texto: "el archivo xlsx esta mal formado",
              icono: "error",
            });
            setActivate(false);
          }

          if (titulo_sigue === true && produc_sigue === true) {
            seleccionarRegistros(produc);
            setHeadCells(titulos);
          } else {
            setHeadCells([]);
            setInsertProduct([]);
            setUpdateProduct([]);
          }
        };
      }
    } else {
      txtFile.current.value = "";
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  const procesarPrecioProd = (cursorProduct, fileProduct) => {
    let element = fileProduct;
    const element0 = [];
    const viejos = [];
    let nuevos = [];

    for (let i = 0; i < fileProduct.length; i++) {
      for (let x = 0; x < cursorProduct.length; x++) {
        if (
          cursorProduct[x].toString().trim().toUpperCase() ===
          fileProduct[i][1].toString().trim().toUpperCase()
        ) {
          viejos.push(fileProduct[i][1]);
          element0.push(fileProduct[i]);
        }
      }
    }

    for (let i = 0; i < element.length; i++) {
      for (let x = 0; x < viejos.length; x++) {
        if (
          viejos[x].toString().trim().toUpperCase() ===
          element[i][1].toString().trim().toUpperCase()
        ) {
          element = element.filter(
            (value) =>
              value[1].toString().trim().toUpperCase() !==
              element[i][1].toString().trim().toUpperCase()
          );
        }
      }
    }
    nuevos = element;

    setInsertProduct(nuevos);
    setUpdateProduct(element0);
    setActivate(false);
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12" style={{ margin: 0 }}>
        <div className="row col-md-12 py-2" style={{ margin: 0 }}>
          <div className="col-md-12 py-3 mx-auto card shadow ">
            <Dimmer active={activate} inverted>
              <Loader inverted>cargando...</Loader>
            </Dimmer>
            <div className="row col-md-12 mx-auto ">
              <div className="input-group input-group-sm mb-2 col-md-12 justify-content-between">
                <input
                  required
                  type="file"
                  name="file"
                  id="file"
                  ref={txtFile}
                  className="form-control col-md-3"
                  onChange={handleInputChange}
                  placeholder="Ingrese Archivo Excel."
                />
              </div>
              {updateProduct.length > 0 && (
                <div className="col-md-6 mx-auto mb-3">
                  <div className="row col-md-12">
                    <h1>PRODUCTOS POR ACTUALIZAR</h1>
                    <button
                      type="button"
                      className="btn btn-warning btn-sm rounded-pill col-md-2 mb-3"
                      onClick={updateProcess}
                    >
                      {" "}
                      Actualizar
                    </button>
                  </div>

                  <TblContainer
                    container={{
                      height: 350,
                      width: "100%",
                      overflow: "auto",
                      padding: "2px",
                    }}
                  >
                    <TblHead />
                    <TableBody className="overflow-hidden">
                      {updateProduct &&
                        updateProduct.map((item, index) => (
                          <TableRow
                            key={index}
                            style={{
                              padding: "0",
                              backgroundColor: "transparent",
                            }}
                          >
                            {Object.values(item) &&
                              Object.values(item).map((item2, x) => (
                                <TableCell
                                  key={x}
                                  className="align-baseline p-0"
                                  style={{
                                    textAlign: "center",
                                    border: "solid 1px #000000",
                                  }}
                                >
                                  {item2}
                                </TableCell>
                              ))}
                          </TableRow>
                        ))}
                    </TableBody>
                  </TblContainer>
                </div>
              )}

              {insertProduct.length > 0 && (
                <div className="col-md-6 mx-auto mb-3">
                  <div className="row col-md-12">
                    <h1>PRODUCTOS POR REGISTRAR</h1>
                    <button
                      type="button"
                      className="btn btn-primary btn-sm rounded-pill col-md-2 mb-3"
                      onClick={insertProcess}
                    >
                      {" "}
                      Registrar
                    </button>
                  </div>

                  <TblContainer
                    container={{
                      height: 350,
                      width: "100%",
                      overflow: "auto",
                      padding: "2px",
                    }}
                  >
                    <TblHead />
                    <TableBody className="overflow-hidden">
                      {insertProduct &&
                        insertProduct.map((item, index) => (
                          <TableRow
                            key={index}
                            style={{
                              padding: "0",
                              backgroundColor: "transparent",
                            }}
                          >
                            {Object.values(item) &&
                              Object.values(item).map((item2, x) => (
                                <TableCell
                                  key={x}
                                  className="align-baseline p-0"
                                  style={{
                                    textAlign: "center",
                                    border: "solid 1px #000000",
                                  }}
                                >
                                  {item2}
                                </TableCell>
                              ))}
                          </TableRow>
                        ))}
                    </TableBody>
                  </TblContainer>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default FileExcelClientes;



// WEBPACK FOOTER //
// ./src/components/almacen/archivosExcelCliente.js